<script>
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";

export default {
  name: "GrievanceCaseResolutionForm",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    record: null,
  },
  data() {
    return {
      form: {
        systemId: "",
        resolution: "",
      },
      valid: true,
      loading: false,
      required: [(v) => !!v || "Field is required"],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    caseTypes() {
      return this.$store.getters["Grievances/grievanceGetters"]("caseTypes");
    },
    user() {
      return AuthService.user;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.form = {
          systemId: this.record?.systemId || "",
          resolution: this.record?.resolution || "",
        };

        this.valid = true;

        this.$nextTick(() => {
          this.$refs.formRef?.resetValidation();
        });
      }
    },
  },
  methods: {
    submit() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        const operation = "updateCase";
        this.$store
          .dispatch(`Grievances/${operation}`, this.form)
          .then(() => {
            this.valid = true;
            this.$refs.formRef.reset();
            this.$refs.formRef?.resetValidation();
            this.close();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    close() {
      this.valid = true;
      this.$refs.formRef?.resetValidation();
      this.dialog = false;
    },
  },
};
</script>

<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5"
          >Grievance Case Resolution Form: {{ record ? record.no : "" }}</span
        >
      </v-card-title>

      <v-card-text>
        <!-- Case context (visible to user) -->
        <v-sheet class="pa-3 mb-4" color="grey lighten-4" rounded>
          <div class="mb-2">
            <strong>Case Type:</strong> {{ record ? record.caseType : "" }}
          </div>

          <div>
            <strong>Description:</strong> {{ record ? record.description : "" }}
          </div>
        </v-sheet>

        <v-form ref="formRef" v-model="valid" lazy-validation>
          <v-textarea
            outlined
            label="Resolution *"
            v-model="form.resolution"
            rows="3"
            :rules="required"
          ></v-textarea>

          <v-btn @click="close" :disabled="loading" class="mr-2">
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            @click="submit"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
